import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IFireAgency } from 'src/models/fire-agency.model';
import style from './fire-agencies-list.module.scss';
import FireAgenciesAdd from '../fire-agencies-add/fire-agencies-add.component';
import FireAgenciesEdit from '../fire-agencies-edit/fire-agencies-edit.component';
import FireAgenciesDelete from '../fire-agencies-delete/fire-agencies-delete.component';

type IProp = {
  data: IFireAgency[];
  loading: boolean;
};

const FireAgenciesView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IFireAgency>[] = [
    {
      title: Lang.LBL_AGENCY_NAME,
      index: 'name',
      width: '35%',
    },
    {
      title: Lang.LBL_AGENCY_RATE,
      index: 'rate',
      render: (_, value) => (
        <>
          <span>
            {value.rate
              ?.toLocaleString(undefined, {
                maximumFractionDigits: 2,
              })
              .concat(' ', Lang.LBL_USD)}
          </span>
        </>
      ),
      width: '50%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <FireAgenciesEdit data={value} />
          <FireAgenciesDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[1].render) {
      customColumns[1].render(true, {} as IFireAgency, 1, {} as any);
    }
    if (customColumns[2].render) {
      customColumns[2].render(true, {} as IFireAgency, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_FIRE_AGENCIES} />
        <FireAgenciesAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default FireAgenciesView;
